export enum AttachmentSortingOption {
  NAME = 'name',
  FILE_CATEGORY = 'fileCategory',
  FILE_TYPE = 'fileType',
  FORM_CATEGORY = 'formCategory',
  FORM_TYPE = 'formType',
  SOURCE = 'source',
  WORKFLOW_TITLE = 'workflowTitle',
  WORKFLOW_STATUS = 'workflowStatus',
  LOCATION = 'location',
  COMPANY = 'company',
  UPLOADED_BY = 'uploadedBy',
  DATE_UPLOADED = 'dateUploaded',
}
